// main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Keycloak from 'keycloak-js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const keycloak = new Keycloak({
 url: 'https://alpha.currentjobs.co.ke/auth/',
 realm: 'Notfyi',
 clientId: 'notfyi_jobs_admin_dashboard',
});

const styles = {
  lostContainer: {
    textAlign: 'center',
    marginTop: '80px',
    fontFamily: 'sans-serif',
  },
  image: {
    maxWidth: '500px',
    width: '90%',
    marginTop: '20px',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
  },
  text: {
    fontSize: '24px',
    color: '#555',
  },
};

const LostPage = ({ username }) => {
  const accountUrl = window.keycloak ? window.keycloak.createAccountUrl() : '#';
  
  return (
    <div>
      <div style={{ padding: '12px 24px', backgroundColor: 'var(--bg-secondary)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid var(--border-color)' }}>
        <div>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px', verticalAlign: 'middle' }}>
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <a 
            href={accountUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', color: 'var(--text-primary)', fontWeight: '500' }}
          >
            {username}
          </a>
        </div>
      
        <button
          onClick={() => window.keycloak.logout({ redirectUri: window.location.origin })}
          className="btn-secondary"
        >
          Logout
        </button>
      </div>
    <div style={styles.lostContainer}>
      <h2 style={styles.text}>Oops! You're lost...</h2>
      <img src="../public/og-image.png" alt="You're lost" style={styles.image} />
    </div>
  </div>
  );
};

keycloak
  .init({
    onLoad: 'login-required',
    pkceMethod: 'S256',
    checkLoginIframe: false,
  })
  .then(authenticated => {
    if (authenticated) {
      window.keycloak = keycloak;
      const username = keycloak.tokenParsed?.preferred_username || 'Unknown User';
      const roles = keycloak.tokenParsed?.realm_access?.roles || [];
      const hasJobsAdminRole = roles.includes('jobsAdmin');

      ReactDOM.createRoot(document.getElementById('root')).render(
        <React.StrictMode>
          {hasJobsAdminRole ? <App /> : <LostPage username={username} />}
          <ToastContainer />
        </React.StrictMode>
      );
    } else {
      keycloak.login();
    }
  })
  .catch(error => {
    console.error('Keycloak init error:', error);
  });
